/**
 * Season Start Dates Configuration
 *
 * This file defines the official start dates for each season.
 * These dates determine:
 * 1. When facilities can begin applying corporate menus (start date)
 * 2. The 28-day window for allowed application dates (start date + 27 days)
 * 3. Season boundaries for meal validity
 *
 * Update these dates annually as needed.
 *
 * NOTE: Months are 1-indexed (1=January, 2=February, ..., 12=December)
 * This makes it easier for non-technical users to update the configuration.
 *
 * IMPORTANT: This is the SINGLE source of truth for season dates.
 * Both frontend and backend import from this shared file.
 */

export const SEASON_DATES = {
  'spring-summer': {
    // Spring-Summer: April 19
    month: 4, // 1-indexed: 1=Jan, 2=Feb, ..., 4=Apr
    day: 19,
    // Allowed application window: Apr 19 - May 17 (28 days)
    // Meals valid through: Apr 19 - Oct 18
  },
  'fall-winter': {
    // Fall-Winter: October 19
    month: 10, // 1-indexed: 10=Oct
    day: 19,
    // Allowed application window: Oct 19 - Nov 16 (28 days)
    // Meals valid through: Oct 19 - Apr 12 (next year)
  },
};

/**
 * Get the season start date for a given season
 * @param {string} season - 'spring-summer' or 'fall-winter'
 * @param {number} year - The year (not used, kept for API compatibility)
 * @returns {{ month: number, day: number }} - The start date (month is 0-indexed for dayjs/Date compatibility)
 */
export const getSeasonStartDate = (season, year) => {
  const seasonConfig = SEASON_DATES[season];
  if (!seasonConfig) {
    throw new Error(`Invalid season: ${season}`);
  }

  // Convert from 1-indexed (user-friendly) to 0-indexed (dayjs/Date format)
  return {
    month: seasonConfig.month - 1,
    day: seasonConfig.day,
  };
};
